import { render } from "./VacunaPersTabla03.vue?vue&type=template&id=359d3a2c"
import script from "./VacunaPersTabla03.vue?vue&type=script&lang=js"
export * from "./VacunaPersTabla03.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__